<template>
    <Faq :id="id"/>
</template>
<script>
import Faq from '@/components/Faq.vue';

export default {
    name: 'FaqProfile',
    components: {
        Faq
    },
    data() {
        return {
            id: null,
        }   
    },
    mounted() {
        this.id = this.$route.params.id ? +this.$route.params.id : null;
    },
}
</script>
